import React from 'react';
import Icon from '../../../components/AppIcon';
import Select from '../../../components/ui/Select';

const SortControls = ({ sortBy, onSortChange, resultCount }) => {
  const sortOptions = [
    { value: 'relevance', label: 'Most Relevant' },
    { value: 'deadline-asc', label: 'Deadline (Earliest First)' },
    { value: 'deadline-desc', label: 'Deadline (Latest First)' },
    { value: 'name-asc', label: 'Name (A-Z)' },
    { value: 'name-desc', label: 'Name (Z-A)' },
    { value: 'students-desc', label: 'Most Popular' }
  ];

  return (
    <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 bg-card rounded-lg p-4 shadow-warm-sm border border-border">
      <div className="flex items-center gap-2">
        <Icon name="List" size={20} color="var(--color-primary)" />
        <span className="text-sm font-medium text-foreground font-caption">
          {resultCount} {resultCount === 1 ? 'institution' : 'institutions'} found
        </span>
      </div>

      <div className="w-full sm:w-auto min-w-[200px]">
        <Select
          label="Sort by"
          options={sortOptions}
          value={sortBy}
          onChange={onSortChange}
        />
      </div>
    </div>
  );
};

export default SortControls;